import { ReactNode } from 'react'
import { WidgetMicroButton } from './widget-micro-button'

export interface WidgetInputWithActionProps {
	children: ReactNode
	onClick: () => void
	icon: ReactNode
	title: string
	disabled?: boolean
}

/**
 * Wraps any widget input with a micro button to the right.
 * Use this when a field needs an attached action (e.g. opening a picker).
 */
export function WidgetInputWithAction({ children, onClick, icon, title, disabled }: WidgetInputWithActionProps) {
	return (
		<div className="flex items-center gap-1">
			<div className="flex-1 min-w-0">
				{children}
			</div>
			<WidgetMicroButton onClick={onClick} title={title} disabled={disabled}>
				{icon}
			</WidgetMicroButton>
		</div>
	)
}
